import { createFileRoute } from "@tanstack/react-router";

import FaqPage from "@/features/faq/Faq";

export const Route = createFileRoute("/_auth/faq")({
  component: FaqPage,
});
